/**
 * Cleaning a diagram's SVG before it is written into the page.
 *
 * Mermaid's `securityLevel: 'strict'` already sanitizes labels, but the source
 * comes from a file anyone may have written, and a diagram is the one place
 * the editor writes markup into the page. Defense in depth: DOMPurify keeps the
 * drawing (SVG, its <style>, and the HTML labels inside <foreignObject>) and
 * drops anything that could run.
 *
 * Its own module, importing nothing but DOMPurify, so the end-to-end tests can
 * bundle just this and run it in real browsers (e2e/sanitize.test.ts). A fake
 * DOM cannot tell whether markup inside a foreignObject is neutralized.
 */
import DOMPurify from 'dompurify'

export function cleanSvg(svg: string): string {
  return DOMPurify.sanitize(svg, {
    USE_PROFILES: { svg: true, svgFilters: true, html: true },
    ADD_TAGS: ['foreignObject', 'style'],
    HTML_INTEGRATION_POINTS: { foreignobject: true },
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  })
}
